module.exports = __webpack_public_path__ + "img/ic_date_active.4f63071a.svg";